import React, { useEffect, useState, useMemo } from "react";
import api from "../services/api";
import "./PublicStorePage.css";

const PublicStorePage = ({
  searchQuery = "",
  categoryFilter = "",
  onAddToBag = () => {}
}) => {

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isBuyNow, setIsBuyNow] = useState(false);
  const [imageIndexMap, setImageIndexMap] = useState({});

  const [showMeterPopup, setShowMeterPopup] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [meterInput, setMeterInput] = useState("");

  const getImageIndex = (productId) => imageIndexMap[productId] || 0;

  const setImageIndex = (productId, index) => {
    setImageIndexMap((prev) => ({
      ...prev,
      [productId]: index,
    }));
  };

  // ---------------- FETCH ----------------

  const fetchProducts = async () => {
    try {
      const res = await api.get("/selfstore/all");
      const list = Array.isArray(res.data.data) ? res.data.data : [];
      setProducts(list);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // ---------------- ADD TO BAG ----------------

  const handleAddToBag = (product) => {
    setSelectedProduct(product);
    setMeterInput("");
    setShowMeterPopup(true);
  };

  const confirmAddToBag = () => {

    if (!meterInput) {
      alert("Enter meters");
      return;
    }

    const selectedIndex = getImageIndex(selectedProduct._id);
    const selectedImage = selectedProduct.imageUrls?.[selectedIndex] || "";

    const meters = Number(meterInput);

    const item = {
      _id: selectedProduct._id + "_" + Date.now(),
      productName: selectedProduct.productName,
      cost: meters * selectedProduct.cost,
      meters,
      imageUrl: selectedImage
    };

    console.log("ADDING TO BAG:", item);

    onAddToBag(item);

    setShowMeterPopup(false);
  };

  // ---------------- FILTER ----------------

  const filteredProducts = useMemo(() => {

    let list = products;

    if (categoryFilter) {
      list = list.filter(
        (p) =>
          (p.category || "").toLowerCase() === categoryFilter.toLowerCase()
      );
    }

    if (!searchQuery) return list;

    const q = searchQuery.toLowerCase();

    return list.filter(
      (p) =>
        p.productName.toLowerCase().includes(q) ||
        (p.description || "").toLowerCase().includes(q)
    );

  }, [products, categoryFilter, searchQuery]);

  return (

    <div className="store-container">

      <div className="product-grid">

        {loading && <p>Loading...</p>}

        {filteredProducts.map((p) => {

          const selectedIndex = getImageIndex(p._id);

          return (

<div key={p._id} className="product-card">

  {/* MAIN IMAGE */}
  <div className="image-wrapper">
    <img
      src={p.imageUrls?.[selectedIndex]}
      alt={p.productName}
      className="main-image"
    />
  </div>

  {/* THUMBNAILS */}
  <div className="thumbnail-scroll">
    {p.imageUrls?.map((img, idx) => (
      <img
        key={idx}
        src={img}
        className={`thumb ${selectedIndex === idx ? "active" : ""}`}
        onClick={() => setImageIndex(p._id, idx)}
        alt="thumb"
      />
    ))}
  </div>

  {/* TEXT CONTENT */}
  <div className="card-content">

    <h3 className="product-title">{p.productName}</h3>

    <p className="product-desc">
      How do you want to use the material. Click to know the quantity
    </p>

    <p className="price">₹{p.cost} per meter</p>

    <div className="btn-row">
      <button className="btn-bag" onClick={() => handleAddToBag(p)}>
        Add to Bag
      </button>

      <button
        className="btn-buy"
        onClick={() => {
          setSelectedProduct(p);
          setMeterInput("");
          setIsBuyNow(true); // ⭐ important
          setShowMeterPopup(true);
        }}
      >
        Buy Now
      </button>
    </div>

  </div>

</div>

          );

        })}

      </div>

      {/* METER POPUP */}
      {showMeterPopup && (
        <div className="checkout-overlay">
          <div className="checkout-box">

            <h3>Enter Meters</h3>

            <input
              type="number"
              value={meterInput}
              onChange={(e) => setMeterInput(e.target.value)}
            />

            <button onClick={confirmAddToBag}>
              Add
            </button>

            <button onClick={() => setShowMeterPopup(false)}>
              Cancel
            </button>

          </div>
        </div>
      )}

    </div>

  );

};

export default PublicStorePage;